// --- React
import React from "react";
// --- External UI Libraries
import Button from "@dtci/spellbook/Button";
import Typography from "@dtci/spellbook/Typography";
// --- Components
import { DetailsModal } from "tap/components/DetailsModal/index.jsx";
// --- Config
import { RELEASE_NOTES } from "tap/config/releaseNotes.js";

/**
 * ReleaseNotesModal Component
 *
 * Displays release notes for the current version and prior releases.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onClose - Handler to close the modal
 */
export function ReleaseNotesModal({ isOpen, onClose }) {
  return (
    <DetailsModal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader="Release Notes"
      footer={
        <div className="release-notes-modal__footer">
          <Button onClick={onClose}>Close</Button>
        </div>
      }
    >
      <div className="release-notes-modal">
        {RELEASE_NOTES.map((release, index) => (
          <section
            key={release.version}
            className={
              index === 0
                ? "release-notes-modal__section release-notes-modal__section--current"
                : "release-notes-modal__section"
            }
          >
            <Typography variant={index === 0 ? "T30" : "T20"}>
              {release.version}
              {release.releaseDate ? ` (${release.releaseDate})` : ""}
            </Typography>
            {release.sections?.length > 0 ? (
              release.sections.map((section) => (
                <div
                  key={section.title}
                  className="release-notes-modal__subsection"
                >
                  <Typography variant="T20">{section.title}</Typography>
                  {section.description ? (
                    <Typography
                      className="release-notes-modal__description"
                      variant="T15"
                    >
                      {section.description}
                    </Typography>
                  ) : null}
                  {section.items?.length > 0 ? (
                    <ul className="release-notes-modal__list">
                      {section.items.map((item) => (
                        <li key={item}>
                          <Typography variant="T15">{item}</Typography>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              ))
            ) : release.items?.length > 0 ? (
              <ul className="release-notes-modal__list">
                {release.items.map((item) => (
                  <li key={item}>
                    <Typography variant="T15">{item}</Typography>
                  </li>
                ))}
              </ul>
            ) : (
              <Typography variant="T15">No notes for this release.</Typography>
            )}
          </section>
        ))}
      </div>
    </DetailsModal>
  );
}
